import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-expansion-panel',
  templateUrl: './expansion-panel.component.html',
  styleUrls: ['./expansion-panel.component.scss'],
  standalone: true,
  imports: [CommonModule, MatExpansionModule, MatIconModule],
})
export class ExpansionPanelComponent {
  @Input() title: string = '';
  @Input() content: string = '';
  @Input() icon: string = '';
  @Input() svgIcon: string = '';
  @Input() set shouldPanelOpen(openState: boolean) {
    this.panelOpenState = openState;
  }
  @Input() customClass: string = '';
  protected panelOpenState: boolean = false;
}
